<!--TODO: The file that equivalent of this file should be removed from ui-components-->
<template>
  <ShopPerformanceSkeleton v-if="loading" />
  <div v-else class="performance">
    <div class="d-flex justify-between items-start">
      <h1 v-if="!isMobile" class="performance_title">Mağaza Performansı</h1>
    </div>
    <div class="performance_content">
      <span class="performance_content_title">Bugünkü Satış</span>
      <strong class="performance_content_money">
        {{ sellerPerformanceMetrics.formattedTodaySaleAmount || "0₺" }}
      </strong>
      <!-- <div class="performance_content_percent">
        <span class="performance_content_percent_status" />
        %-20
      </div> -->
    </div>
    <div class="performance_content">
      <span class="performance_content_title">Son 1 Haftalık Satış</span>
      <strong class="performance_content_money">
        {{ sellerPerformanceMetrics.formattedWeeklySaleAmount || "0₺" }}
      </strong>
      <!-- <div class="performance_content_percent">
        <span class="performance_content_percent_status" />
        %-20
      </div> -->
    </div>
    <div class="performance_content">
      <span class="performance_content_title">Son 1 Aylık Satış</span>
      <strong class="performance_content_money">
        {{ sellerPerformanceMetrics.formattedMonthlySaleAmount || "0₺" }}
      </strong>
      <!-- <div class="performance_content_percent">
        <span class="performance_content_percent_status" />
        %-20
      </div> -->
    </div>
    <div v-if="isReadyToPay" class="performance_pay_ready">
      <div class="performance_pay_ready_wrapper">
        <div class="performance_pay_ready_title">Ödeme Bilgileri</div>
        <div class="performance_pay_info">
          <div class="performance_pay_ready_date">
            <span class="label">Ödeme Tarihi</span>
            <span class="value">{{ settlementDay }}</span>
          </div>
          <div class="performance_pay_ready_amount">
            <span class="label">Ödenecek Tutar</span>
            <span class="value_revenue">{{ formattedTodaysRevenue }}₺</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="performance_pay_waiting">
      <div class="performance_pay_ready_wrapper_info">
        <span class="performance_pay_waiting_title">Ödeme Bilgileri</span>
        <div class="performance_pay_waiting_description">
          {{ sellerPerformanceMetrics.revenueInfoText }}
        </div>
      </div>
    </div>
    <div class="performance_pay_early_settlement">
      <template v-if="sellerPerformanceMetrics.earlySettlementDate">
        <div class="performance_pay_early_settlement_wrapper">
          <div class="performance_pay_early_settlement_title">Erken Ödeme Bilgilerim</div>
          <div class="performance_pay_early_settlement_info">
            <div class="performance_pay_early_settlement_row">
              <span class="performance_pay_early_settlement_row_label">Erken Ödeme Tarihi</span>
              <span class="performance_pay_early_settlement_row_value date">
                {{ earlySettlementDate }}
              </span>
            </div>
            <div class="performance_pay_early_settlement_row">
              <span class="performance_pay_early_settlement_row_label">Erken Ödenecek Tutar</span>
              <span class="performance_pay_early_settlement_row_value revenue">
                {{ earlySettlementAmount }}
              </span>
            </div>
          </div>
        </div>
        <button
          class="performance_pay_early_settlement_button_go_detail"
          type="button"
          @click="goToEarlySettlement"
        >
          <span>Erken Ödeme Detayına Git</span>
          <Icons name="RightArrows" size="md" color="black" />
        </button>
      </template>
      <template v-else>
        <button
          class="performance_pay_early_settlement_button_request_early_settlement"
          type="button"
          @click="goToEarlySettlement"
        >
          <div class="performance_pay_early_settlement_button_request_early_settlement_title">
            <span>Şimdi Erken Ödeme Talep Edin</span>
            <Icons name="RightArrows" size="md" color="black" />
          </div>
          <div class="performance_pay_early_settlement_button_request_early_settlement_description">
            Kazancınız <span>hemen ilk iş günü</span> hesabınıza yatsın! 
          </div>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import ShopPerformanceSkeleton from "@/components/ShopPerformance/ShopPerformanceSkeleton";
import { Icons } from "@n11/so-ui-components";
import {
  formatDateToTurkishLong,
} from "@/utils/formatedDate";

export default {
  name: "ShopPerformance",
  props: {
    sellerPerformanceMetrics: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
  },
  components: {
    ShopPerformanceSkeleton,
    Icons,
  },
  setup(props) {
    const router = useRouter();
    const size = ref(window.innerWidth);
    const isMobile = computed(() => {
      return size.value < 768;
    });
    const isReadyToPay = computed(() => {
      return props.sellerPerformanceMetrics.todaysRevenue > 0;
    });
    const settlementDay = computed(() => {
      return formatDateToTurkishLong(
        props.sellerPerformanceMetrics.settlementDate
      );
    });

    const formattedTodaysRevenue = computed(() => {
      const value = props.sellerPerformanceMetrics.todaysRevenue || 0;
      return new Intl.NumberFormat("tr-TR", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    });

    const earlySettlementDate = computed(() => {
      return formatDateToTurkishLong(props.sellerPerformanceMetrics.earlySettlementDate);
    });

    const earlySettlementAmount = computed(() => {
      return props.sellerPerformanceMetrics.formattedEarlySettlementAmount || "0";
    });

    const goToEarlySettlement = () => {
      router.push("/settlement/earlySettlement");
    };

    return {
      size,
      isMobile,
      isReadyToPay,
      settlementDay,
      formatDateToTurkishLong,
      formattedTodaysRevenue,
      earlySettlementDate,
      earlySettlementAmount,
      goToEarlySettlement,
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";
@import "@/assets/styles/utilities.scss";

.performance {
  width: 100%;
  padding: 20px 0 0;
  border-radius: 8px;
  background-color: $colorN00;
  font-family: "Open Sans", sans-serif !important;

  &_title {
    margin: 0 0px 14px 20px;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.1px;
    color: $colorN80;
  }

  &_content {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 8px 20px;

    &_title {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.05px;
    }

    &_money {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: -0.2px;
    }

    &_percent {
      margin: 2px 20px 0px 0px;
      font-size: 12px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: $cardinal;
      display: block;

      &_status {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 5px 4px 0 4px;
        border-color: $american-red transparent transparent transparent;
        display: inline-flex;
      }
    }
  }

  &_divider {
    max-width: 286px;
    height: 1px;
    margin: 8px 20px;
    background-color: $gray-1;
  }

  &_pay_ready {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 326px;
    padding: 14px 20px 12px;
    border-radius: 6px;
    background-position: top;
    background-repeat: repeat-x;
    background-size: 18px 8px;

    &_content {
      display: flex;
      flex-direction: column;
    }

    &_wrapper {
      width: 100%;

      &_info {
        background-color: $colorD05;
        padding: 12px;
        border-radius: 6px;
      }
    }

    &_title {
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: -0.1px;
      padding-bottom: 16px;
      color: $colorN80;
    }

    &_money {
      font-size: 18px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: right;
      float: right;
    }

    &_date {
      margin: 4px 0 0 1px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: right;
      padding-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: baseline;
    }

    &_amount {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
    }

    &_formatted_date {
      text-align: right;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: $green-7;
    }
  }


  &_pay_early_settlement {
    display: flex;
    flex-direction: column;
    width: 326px;
    padding: 12px 20px 20px;
    gap: 16px;
    border-radius: 6px;
    background-position: top;
    background-repeat: repeat-x;
    background-size: 18px 8px;

    &_wrapper {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }

    &_info {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    &_title {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: -0.1px;
      color: $colorN80;
    }

    &_row {
      display: flex;
      justify-content: space-between;
      align-items: baseline;

      &_label {
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.4px;
        color: #242424;
      }
      
      &_value {
        font-size: 19px;
        font-weight: 700;
        line-height: 26px;
        letter-spacing: -0.2px;
        color: $colorN80;
        text-align: right;
        white-space: nowrap;

        &.date {
          letter-spacing: -0.6px;
        }
        &.revenue {
          color: $colorM50;
          font-weight:700;
        }
      }
    }

    & button {
      width: 100%;
      padding: 8px 10px;
      border-radius: 8px;
      border: none;
      background-color: $colorL50;
      color: $colorN80;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.05px;
    }

    &_button_go_detail {
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &_button_request_early_settlement {
      height: 60px;
      display: flex;
      flex-direction: column;
      gap: 4px;

      &_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      &_description {
        text-align: left;
        font-size: 12px;
        font-weight: 400;

        & span {
          font-weight: 600;
        }
      }
    }
  }


  &_pay_waiting {
    width: 100%;
    min-width: 326px;
    margin: 12px 0 0;
    padding: 8px 20px 20px;
    border-radius: 6px;
    background-position: top;
    background-repeat: repeat-x;
    background-size: 18px 8px;

    &_title {
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: -0.1px;
    }

    &_money {
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      float: right;
    }

    &_description {
      margin: 4px 0 0;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: -0.05px;
    }
  }
}

.performance_pay_info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 14px;
  color: #2b2b2b;
}

.label {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
  color: #242424;
}

.value {
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: -0.2px;
  color: $colorN80;
  &_revenue {
    color: $colorM50;
    font-weight:700;
  }
}

.image-position {
  width: 24px;
  height: 24px;
  margin-right: 20px;
  margin-top: -3px;
}
@media screen and (max-width: 768px) {
  .performance_divider {
    max-width: 100%;
  }
}
</style>
